__turbopack_context__.v({
  "accreditation": "Accreditations-module-scss-module__qZ5ocq__accreditation",
  "user-accreditations": "Accreditations-module-scss-module__qZ5ocq__user-accreditations",
  "user-accreditations-container": "Accreditations-module-scss-module__qZ5ocq__user-accreditations-container",
});
